
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Settings, Bell } from 'lucide-react';
import { useNotificationSettings } from './notifications/useNotificationSettings';
import NotificationToggle from './notifications/NotificationToggle';
import NotificationReminderSettings from './notifications/NotificationReminderSettings';
import NotificationSMTPInfo from './notifications/NotificationSMTPInfo';
import NotificationActions from './notifications/NotificationActions';
import NotificationScheduleInfo from './notifications/NotificationScheduleInfo';
import EmailLogs from './notifications/EmailLogs';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const NotificationSettings = () => {
  const {
    settings,
    setSettings,
    isLoading,
    isSaving,
    saveSettings,
    testNotificationSystem
  } = useNotificationSettings();

  if (isLoading) {
    return (
      <Card>
        <CardContent className="flex justify-center items-center p-10">
          <div className="text-center">
            <Settings className="h-8 w-8 animate-spin mx-auto mb-4" />
            <p>Chargement des paramètres...</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <Tabs defaultValue="settings" className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger value="settings">Paramètres</TabsTrigger>
          <TabsTrigger value="email-logs">Historique des emails</TabsTrigger>
        </TabsList>
        
        <TabsContent value="settings">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Bell className="h-5 w-5" />
                Paramètres de Notification
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <NotificationToggle
                isEnabled={settings.is_enabled}
                onToggle={(checked) => setSettings(prev => ({ ...prev, is_enabled: checked }))}
              />

              <NotificationReminderSettings
                reminderDaysLong={settings.reminder_days_long}
                reminderDaysMedium={settings.reminder_days_medium}
                reminderDaysShort={settings.reminder_days_short}
                reminderDaysCritical={settings.reminder_days_critical}
                sendHour={settings.send_hour}
                onReminderDaysLongChange={(value) => setSettings(prev => ({ ...prev, reminder_days_long: value }))}
                onReminderDaysMediumChange={(value) => setSettings(prev => ({ ...prev, reminder_days_medium: value }))}
                onReminderDaysShortChange={(value) => setSettings(prev => ({ ...prev, reminder_days_short: value }))}
                onReminderDaysCriticalChange={(value) => setSettings(prev => ({ ...prev, reminder_days_critical: value }))}
                onHourChange={(value) => setSettings(prev => ({ ...prev, send_hour: value }))}
              />

              <NotificationSMTPInfo />

              <NotificationActions
                isSaving={isSaving}
                onSave={saveSettings}
                onTest={testNotificationSystem}
              />
            </CardContent>
          </Card>

          <NotificationScheduleInfo
            sendHour={settings.send_hour}
            daysBeforeExpiration={Math.min(
              settings.reminder_days_critical,
              settings.reminder_days_short,
              settings.reminder_days_medium,
              settings.reminder_days_long
            )}
          />
        </TabsContent>
        
        <TabsContent value="email-logs">
          <EmailLogs />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default NotificationSettings;
